// extracted by mini-css-extract-plugin
export default {"root":"IntegrationPage_root__DTARv","header":"IntegrationPage_header__6o1Ee"};